import { Directive } from '@angular/core';

@Directive({
  selector: '[tidyCarrousel]'
})
export class TidyCarrouselDirective {}
